
function ChatIcon({ color }: { color: string }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="27"
      height="28"
      fill="none"
      viewBox="0 0 27 28"
    >
      <path
        fill={color}
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M20.25 7.167c.895 0 1.754.33 2.387.915.632.586.988 1.381.988 2.21v8.333c0 .829-.356 1.624-.988 2.21a3.517 3.517 0 01-2.387.915h-5.625L9 24.875V21.75H6.75c-.895 0-1.754-.33-2.386-.915a3.013 3.013 0 01-.989-2.21v-8.333c0-.829.356-1.624.989-2.21a3.517 3.517 0 012.386-.915h13.5z"
      ></path>
      <defs>
        <clipPath id="clip0_3358_9488">
          <rect width="9" height="11" x="17" fill={color} rx="4.5"></rect>
        </clipPath>
      </defs>
    </svg>
  );
}

export default ChatIcon;
